










































































































































































































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { Dialog } from "vant";
import axios from "axios";
import { Notify } from "vant";
import { englishjanala } from "../../protos";
/* eslint-disable @typescript-eslint/class-name-casing */
/* eslint-disable @typescript-eslint/camelcase */
@Component({
  components: {},
})
export default class Questions extends Vue {
  QuestionType = englishjanala.question.QuestionType.Enum;
  questinItems = ["MCQ_ANYONE_CHOICE", "MCQ_MULTIPLE_CHOICE", "TRANSLATE_REARRANGE"];
  answerOptions: any = [];
  answer: any = [];
  editedStatus: boolean = false;
  edit_question = false;
  @Prop() Questions!: any;
  @Prop() CategoryId!: any;
  @Prop() Exercise!: any;
  @Prop() Category!: any;
  get getOne() {
    return 1;
  }
  get getZero() {
    return 0;
  }
  DivId = -1;
  currentIndex = -1;
  apiForUpdateExercise = "";

  EditQuestion(index: any) {
    this.currentIndex = index;
    this.edit_question = true;
    this.editedStatus = true;
  }
  getIndex(i: any) {
    return i--;
  }
  MouseHover(DivId: any) {
    this.DivId = DivId;
  }
  MouseLeave() {
    this.DivId = -1;
  }
  mounted() {
    console.warn("hi");
  }
  get splitedList() {
    const splitedStr = this.answer[this.DivId].split(" ");
    return splitedStr;
  }

  DeleteQuestion(index: any) {
    Dialog.confirm({
      title: "Delete",
      message: "Are you sure?",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
    })
      .then(() => {
        this.$delete(this.Exercise.questions, index);
        if (this.$route.name == "main.grammar_chapter") {
          console.log("test");
        } else if (this.Category == "WordListQuestion") {
          this.UpdateWords();
        } else if (this.Category == "conversationQuestion") {
          this.UpdateChapter();
        }
      })
      .catch(() => {
        // on cancel
      });
  }
  @Emit("UpdateWords")
  UpdateWords() {
    return this.Questions;
  }
  @Emit("UpdateChapter")
  UpdateChapter() {
    return this.Questions;
  }
  SaveExercise() {
    let data: any;
    if (this.Category == "WordListQuestion") {
      this.UpdateWords();
      return;
    } else if (this.Category == "conversationQuestion") {
      this.UpdateChapter();
      return;
    } else if (this.Category == "podcast") {
      data = { podcast_id: this.CategoryId, exercise: this.Exercise };
    } else data = { category_id: this.CategoryId, exercise: this.Exercise };
    if (this.Category == "word") {
      this.apiForUpdateExercise =
        "https://api.englishjanala.com:8443/v1/englishjanala/word/WordService/UpdateWordExercise";
    } else if (this.Category == "conversation") {
      this.apiForUpdateExercise =
        "https://api.englishjanala.com:8443/v1/englishjanala/conversation/ConversationService/UpdateConversationExercise";
    } else if (this.Category == "grammar") {
      this.apiForUpdateExercise =
        "https://api.englishjanala.com:8443/v1/englishjanala/grammar/GrammarService/UpdateGrammarExercise";
    } else if (this.Category == "podcast") {
      this.apiForUpdateExercise =
        "https://api.englishjanala.com:8443/v1/englishjanala/podcast/PodcastService/UpdatePodcastExercise";
    }
    const response = axios
      .post(this.apiForUpdateExercise, data)
      .then()
      .catch((error) => {
        Notify({ type: "danger", message: "Exercise is not Updated" });
      });
    Notify({ type: "success", message: "Exercise is Updated" });
  }
}
